import { createContext } from 'react';

import { MapContextValue } from './map-types';

export const MapContext = createContext<MapContextValue>({
  map: { current: null },
  isLoaded: false,
});
